import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import Bg403 from '@/assets/403_2.svg'
import Bg404 from '@/assets/404_2.svg'
import Bg500 from '@/assets/500_2.svg'
import useLocale from '@/utils/useLocale'
import styles from './style/index.module.less'
import { NOT_VERIFIED, SUCCESS_CODE } from '@/utils/constants'
import { updateUserEmailApi } from '@/api/common'
import { useSelector } from 'react-redux'
import { StoreState } from '@/store'
import { Message, Spin, Empty, Result, Button } from '@arco-design/web-react'

type Props = {
  code: '403' | '404' | '405' | '500' | typeof NOT_VERIFIED
  message?: string
}

const Exception: FC<Props> = (props) => {
  const t = useLocale()
  const router = useRouter()
  const { userInfo } = useSelector((state: StoreState) => state.global)
  const { email } = userInfo
  const [loading, setLoading] = useState(false)

  const errorMap = {
    '403': {
      bg: <Bg403 />,
      title: t['403.title'],
      subTitle: props?.message || t['403.subtitle']
    },
    '404': {
      bg: <Bg404 />,
      title: t['404.title'],
      subTitle: props?.message || t['404.subtitle']
    },
    '405': {
      bg: <Result status="warning"></Result>,
      title: '',
      subTitle: props?.message || t['title.405']
    },
    '500': {
      bg: <Bg500 />,
      title: t['500.title'],
      subTitle: props?.message || t['500.subtitle']
    },
    [NOT_VERIFIED]: {
      bg: <Bg403 />,
      title: t['403.title'],
      subTitle: (
        <div style={{ fontSize: '16px', textAlign: 'center' }}>
          <div>{t['exception.not.verified1']}</div>
          <div>{t['exception.not.verified2']}</div>
        </div>
      )
    }
  }

  const error = errorMap[props.code]
  const is500WithRetry = props.code === '500' && !router.pathname.startsWith('/500')
  const isNotVerified = props.code === NOT_VERIFIED
  const buttonProps = is500WithRetry
    ? {
        onClick: () => {
          router.reload()
        },
        children: t['exception.retry']
      }
    : isNotVerified
    ? {
        onClick: () => {
          if (email) {
            setLoading(true)
            updateUserEmailApi({ email })
              .then((res) => {
                if (res.data.code === SUCCESS_CODE) {
                  Message.success(t['userSetting.email.verify'])
                }
              })
              .finally(() => {
                setLoading(false)
              })
          }
        },
        children: t['exception.send.email']
      }
    : {
        onClick: () => {
          router.replace('/board')
        },
        children: t['back.home']
      }

  return (
    <Spin loading={loading} style={{ width: '100%' }}>
      <div className={styles.wrapper}>
        <div className={styles.result}>
          {error.bg}
          {error.title && <div className={styles.title}>{error.title}</div>}
          {error.subTitle && <div className={styles.subtitle}>{error.subTitle}</div>}
          <div className={styles.btn} {...buttonProps}></div>
          {isNotVerified && (
            <div
              className={`${styles.btn} ${styles['outline-btn']}`}
              onClick={() => {
                router.replace('/board').then(() => {
                  window.location.reload()
                })
              }}
            >
              {t['btn.verify_already']}
            </div>
          )}
        </div>
      </div>
    </Spin>
  )
}

export default Exception
